import React from "react";
import ShopLogin from "../components/Shop/ShopLogin";

const ShopLoginPage = () => {
  return <ShopLogin />;
};

export default ShopLoginPage;
